export const PASSPORT_TYPES = {
  rf: 'Паспорт РФ',
  uamut: 'Паспорт ИГ (Украина, Азербайджан, Молдова, Узбекистан, Таджикистан)',
  other: 'Паспорт ИГ (другие страны)',
  tempreg: 'Временная регистрация'
}
